import loadable from '@loadable/component';

export const ReportsDetailGraphicConfigurationFilterFeedbackStatus = loadable(
  () => import('./ReportsDetailGraphicConfigurationFilterFeedbackStatus'),
);
